import { ColumnsType } from 'antd/lib/table';
import { handleCurrency, handleNullValues } from 'components/ui/base/table/TableUtils';
import { GoodsShipmentItem } from 'store/declarations/ireland/h7-import-declaration';
import getItemNumberColumn from 'views/declarations/common/getItemNumberColumn';

const getH7ProductsTableColumns = (): ColumnsType<any> => [
    getItemNumberColumn((record: GoodsShipmentItem) => record.goodsItemNumber),
    {
        title: 'Code & Description',
        key: 'commodity_code',
        render: (_, record: GoodsShipmentItem) => {
            const code = record?.commodityCodeHarmonizedSystemSubHeadingCode;
            const description = record?.descriptionOfGoods;
            return (
                <div>
                    <div>{handleNullValues(code)}</div>
                    {description != null && <div>{handleNullValues(description)}</div>}
                </div>
            );
        },
        sorter: true,
    },
    {
        title: 'Item Price',
        dataIndex: 'item_price',
        key: 'item_price',
        render: (_, record: GoodsShipmentItem) =>
            handleNullValues(
                handleCurrency(
                    record?.itemAmountInvoicedIntrinsicValue?.valueAmount,
                    record?.itemAmountInvoicedIntrinsicValue?.valueCurrency
                )
            ),
        sorter: (a: GoodsShipmentItem, b: GoodsShipmentItem) =>
            (a.itemAmountInvoicedIntrinsicValue?.valueAmount ?? 0) -
            (b.itemAmountInvoicedIntrinsicValue?.valueAmount ?? 0),
    },
];

export default getH7ProductsTableColumns;
